import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DisplayMap from '../../DisplayMap/index.tsx';
import { SearchModes } from '../../../constants';

const Map = ({ tripId, onMarkerClick, hoveredMarkerKey }) => {
  const isTripSearch = !tripId;
  const { searchResult, selectedSearchMode } = useSelector((store) => store.tripSearch);
  const trip = useSelector((state) => state.trip.selectedTrips[tripId]);

  const markers = useSelector((state) => {
    const hotelSearchState = state.hotel.hotelSearches[tripId];
    const responses = state.hotel.hotelSearchResponses;
    let hotelPins = [];
    if (selectedSearchMode === SearchModes.HOTEL) {
      hotelPins = isTripSearch ? searchResult.hotelPins
        : responses[hotelSearchState.queryString].hotelPins || [];
    } else {
      hotelPins = searchResult.markers || [];
    }
    return hotelPins.filter((hotel) => hotel.cost !== 0);
  });

  let selectedMarkerKey;
  if (trip) {
    if (selectedSearchMode === SearchModes.HOTEL
      && trip.hotelItineraries
      && (Object.keys(trip.hotelItineraries).length > 0)
      && trip.hotelItineraries[0]
      && trip.hotelItineraries[0].hotelKey) {
      selectedMarkerKey = trip.hotelItineraries[0].hotelKey;
    } if ((selectedSearchMode === SearchModes.CUSTOM)
      && trip.customInventoryItinerary && trip.customInventoryItinerary.uniqueKey) {
      selectedMarkerKey = trip.customInventoryItinerary.uniqueKey;
    }
  }
  return (
    <DisplayMap
      markers={markers}
      hoveredMarkerKey={hoveredMarkerKey}
      tripId={tripId}
      onMarkerClick={onMarkerClick}
      selectedMarkerKey={selectedMarkerKey}
    />
  );
};

Map.defaultProps = {
  hoveredMarkerKey: null,
  tripId: undefined,
};

Map.propTypes = {
  tripId: PropTypes.string,
  onMarkerClick: PropTypes.func.isRequired,
  hoveredMarkerKey: PropTypes.string,
};

export default memo(Map);
